import cross from '~/assets/icons/cross.svg';
import hand from '~/assets/icons/hand.svg';
import split from '~/assets/icons/split.svg';
import trash from '~/assets/icons/trash.svg';
import { Item, ItemAction, ItemType } from '~/shared';

export interface InventoryCellProps {
	item?: Item;
	width?: number;
	height?: number;
	disabled?: boolean;
	closed?: boolean;
	activeHand?: boolean;
	placeholderText?: string;
	placeholderImage?: string;
	quickAccessButton?: string;
	isDragging?: boolean;
	help?: boolean;
	helpHover?: boolean;
	hint?: boolean;
	onDragStart?: (e: React.DragEvent) => void;
	onDragOver?: (e: React.DragEvent) => void;
	onDrop?: (e: React.DragEvent) => void;
	onDragEnd?: () => void;
	onAction?: (action: ItemAction, item: Item) => void;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	onClick?: (e: React.MouseEvent) => boolean | void;
	onContextMenu?: (e: React.MouseEvent) => boolean | void;
}

export const selectItems = [
	{ value: 'Надеть', icon: hand },
	{ value: 'Разделить предмет', icon: split },
	{ value: 'Выбросить', icon: trash },
];

export const hintActions = {
	[ItemAction.USE]: {
		name: 'Использовать',
		icon: hand,
	},
	[ItemAction.SPLIT]: {
		name: 'Разделить предмет',
		icon: split,
	},
	[ItemAction.DROP]: {
		name: 'Выбросить',
		icon: trash,
	},
	[ItemAction.EQUIP]: {
		name: 'Надеть',
		icon: hand,
	},
	[ItemAction.UNEQUIP]: {
		name: 'Снять',
		icon: hand,
	},
	[ItemAction.GIVE_HANDS]: {
		name: 'Взять',
		icon: hand,
	},
	[ItemAction.TAKE_HANDS]: {
		name: 'Убрать',
		icon: cross,
	},
};

export const getItemTypeTranslation = (type: ItemType): string => {
	switch (type) {
		// Одежда
		case ItemType.CLOTHES:
			return 'Одежда';

		// Остальные типы
		case ItemType.BACKPACK:
			return 'Рюкзак';
		case ItemType.FOOD:
			return 'Еда';
		default:
			return 'Предмет';
	}
};
